module.exports = __webpack_public_path__ + "media/8_1.5f03db89.wav";